module.exports = __webpack_public_path__ + "media/img/frontend_application/promo-banner-sm-a34d027afaef30155f098a29ab72e381.png";